import Service from "../services/service";

export default class NoteProvider extends Service {
  fetch(query: object = {}): Promise<any> {
    return this.persist({endpoint: 'search', method: 'get', query: query});
  }

  fetchRemaining(query: {offset: number, entry_id: string, form_submission_id: string, q: string}) : Promise<any> {
    return this.persist({endpoint: 'get_remaining', method: 'get', query: query})
  }

  add(json): Promise<any> {
    return this.persist({json: json, method: 'post'});
  }

  save(json): Promise<any> {
    return this.persist({endpoint: json.note.id, json: json});
  }

  destroy(noteId): Promise<any> {
    return this.persist({endpoint: noteId, method: 'delete'});
  }

  persist({endpoint = '', json = {}, method = 'put', query = {}}: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let data = {
        _method: method,
        authenticity_token: this.csrfToken(),
      };

      data = window.AppConfig.mergeJson(data, json, query);

      $.ajax({
        url: `/notes/${endpoint}`,
        type: method,
        dataType: 'json',
        data: data,
      }).done(function (result) {
        resolve(result);
      }).fail(function (result) {
        reject();
      });
    });
  }
}
